/* eslint-disable max-lines */
import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

const HEADER_HEIGHT = 5.12

export const ModalWrapper = styled.div`
	font-size: 1rem;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: transparent;
	z-index: 10;
	visibility: hidden;
	opacity: 0;
	transition: none;

	&.active {
		visibility: visible;
		opacity: 1;
		z-index: ${props => props.zIndex || 100};
	}
`
ModalWrapper.displayName = 'ModalWrapper'

export const ModalMainContainer = styled.div`
	position: absolute;
	width: max-content;
	height: 100%;
	left: auto;
	right: 0;
	bottom: 0;
	transform: none;
	box-shadow: 0px 0.27em 3.33em 0px rgba(0, 0, 0, 0.30);

	&.with-header {
		height: calc(100vh - ${HEADER_HEIGHT}em);
	}

	@media screen and (max-width: ${theme.point820}) {
		overflow-y: auto;
		position: relative;
		height: 100%;
		width: 100%;

		&.with-header {
			height: 100vh;
		}
	}
`
ModalMainContainer.displayName = 'ModalMainContainer'

export const ModalMain = styled.main`
	position: relative;
	background-color: ${colorTheme.modal.background};
	font-size: 1em;
	min-height: 100%;
	border-radius: 0;
	min-width: 25.9em;
	max-width: 25.9em;

	&.dark {
		background: ${colorTheme.modal.dark.background};
	}

	@media screen and (max-width: ${theme.point820}) {
		width: 100%;
		box-sizing: border-box;
		font-size: 1em;
		margin: 0 auto;
		min-height: 100%;
		padding-bottom: 0.01%;
		max-width: initial;
		min-width: initial;
	}
`
ModalMain.displayName = 'ModalMain'

export const ModalHeader = styled.div`
	display: grid;
	align-items: center;
	grid-template-columns: auto min-content;
	padding: 0.5em 1em 0.5em 1.25em;
	height: 4.06em;
	border-bottom: 1px dashed ${colorTheme.modal.header.border};
	border-top: 1px solid transparent;
	box-shadow: 0 0.27em 0.27em ${colorTheme.modal.header.shadow};
	position: sticky;
	top: 0;
	z-index: ${props => props.zIndex || 100};
	background-color: ${colorTheme.modal.header.background};

	&.dark {
		box-shadow: none;
		background-color: ${colorTheme.modal.dark.header.background};
		border-bottom: 1px solid ${colorTheme.modal.dark.header.borderBottom};
		border-top: 1px solid ${colorTheme.modal.dark.header.borderTop};
	}

	@media screen and (max-width: ${theme.point820}) {
		&.dark {
			border-top: none;
		}
	}
`
ModalHeader.displayName = 'ModalHeader'

export const ModalTitle = styled.h2`
	font-weight: 500;
	font-size: 1.25em;
	text-align: left;
	margin-top: 0.09em;

	&.dark {
		color: ${colorTheme.modal.dark.title};
	}
`
ModalTitle.displayName = 'ModalTitle'

export const ModalBody = styled.div`
	max-height: 95vh;
	overflow-y: auto;
	padding: 0.63em 1.25em;

	&.with-header {
		max-height: 80vh;
	}

	@media screen and (max-width: ${theme.point820}) {
		max-height: initial;

		&.with-header {
			max-height: initial;
		}
	}
`
ModalBody.displayName = 'ModalBody'

export const ModalCloseButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.35em;
	height: 1.35em;

	svg {
		cursor: pointer;
		width: 100%;
		height: 100%;
		fill: ${colorTheme.modal.closeKey.icon};
	}

	&.dark {
		svg {
			fill: ${colorTheme.modal.dark.icon};
		}
	}
`
ModalCloseButton.displayName = 'ModalCloseButton'
